import { environment } from "../environments/environment";
import { AppRuntime } from "./app-origin";

export const ApiEndpoints = {
    // --- Wallet API Endpoints (Core Logic) ---
    dwGetNewTokenPage: `${environment.walletbaseApiUrl}${environment.apiUrls.DWGetNewTokenPage}`,
    dwGetEditTokenPage: `${environment.walletbaseApiUrl}${environment.apiUrls.DWGetEditTokenPage}`,
    dwNotifyTokenAdd: `${environment.walletbaseApiUrl}${environment.apiUrls.DWNotifyTokenAdd}`,
    dwNotifyTokenEdit: `${environment.walletbaseApiUrl}${environment.apiUrls.DWNotifyTokenEdit}`,
    dwGetPaymentMethod: `${environment.walletbaseApiUrl}${environment.apiUrls.DWGetPaymentMethod}`,
    dwDeletePaymentMethod: `${environment.walletbaseApiUrl}${environment.apiUrls.DWDeletePaymentMethod}`,
    dwSetAutoRedeem: `${environment.walletbaseApiUrl}${environment.apiUrls.DWSetAutoRedeem}`,
    dwSetDefaultPaymentUrl: `${environment.walletbaseApiUrl}${environment.apiUrls.DWSetDefaultPaymentUrl}`,

    // --- PPI (ParcelPro) Specific Endpoints ---
    PPIAddCreditCard: `${environment.walletbaseApiUrl}${environment.apiUrls.addCreditCard}`,
    PPIEditCreditCard: `${environment.walletbaseApiUrl}${environment.apiUrls.editCreditCard}`,
    PPIListCreditCard: `${environment.walletbaseApiUrl}${environment.apiUrls.listCreditCard}`,
    PPIDeleteCreditCard: `${environment.walletbaseApiUrl}${environment.apiUrls.deleteCreditCard}`,
    PPINotifyCreditCardAdd: `${environment.walletbaseApiUrl}${environment.apiUrls.notifyCreditCardAdd}`,
    PPINotifyCreditCardEdit: `${environment.walletbaseApiUrl}${environment.apiUrls.notifyCreditCardEdit}`,
    PPISetAutoPay: `${environment.walletbaseApiUrl}${environment.apiUrls.DWSetAutoPay}`,
    dwGetPPIAutoRedeem: `${environment.walletbaseApiUrl}${environment.apiUrls.dwGetPPIAutoRedeem}`,
    dwSetPPIAutoRedeem: `${environment.walletbaseApiUrl}${environment.apiUrls.dwSetPPIAutoRedeem}`,

    // --- Session & Profile Endpoints ---
    sessionjwt: `${environment.walletbaseApiUrl}${environment.apiUrls.sessionjwt}`,
    ppiSessionjwt: `${environment.walletbaseApiUrl}${environment.apiUrls.sessionjwtPPI}`,
    profile: `${environment.walletbaseApiUrl}${environment.apiUrls.profile}`,

    // --- Transaction & Summary Endpoints ---
    walletSummary: `${environment.walletbaseApiUrl}${environment.apiUrls.walletSummary}`, 
    walletSetup: `${environment.baseApiUrl}${environment.apiUrls.walletSetup}`,
    walletSetupNextGen: `${environment.walletbaseApiUrlNextGen}${environment.apiUrls.walletSetupNextGen}`,
    transactionHistory: `${environment.walletbaseApiUrl}${environment.apiUrls.transactionHistory}`,
    sourceIdentifier: `${environment.walletbaseApiUrl}${environment.apiUrls.sourceIdentifier}`,
    invoicedetails: `${environment.walletbaseApiUrl}${environment.apiUrls.invoiceDetails}`,

    // --- Payments & Redemption ---
    getAutoPaySequence: `${environment.walletbaseApiUrl}${environment.apiUrls.getAutoPaySequence}`,
    setAutoPay: `${environment.baseApiUrl}${environment.apiUrls.setAutoPay}`,
    redeemEarn: `${environment.walletbaseApiUrl}${environment.apiUrls.redeemEarn}`,
    cashTransactionApiUrl: `${environment.walletbaseApiUrl}${environment.apiUrls.cashTransactionApiUrl}`,
    invoicepaymentApiUrl: `${environment.baseApiUrl}${environment.apiUrls.invoicepaymentApiUrl}`,
    ppiinvoicepaymentApiUrl: `${environment.walletbaseApiUrl}${environment.apiUrls.ppiinvoicepaymentApiUrl}`,
  
    // --- Start Session & Callbacks (CRITICAL DYNAMIC CHANGE) ---
    startWalletSession: `${environment.baseApiUrl}${environment.apiUrls.startWalletSession}`,
    /**
     * Using AppRuntime.origin ensures that if the user is on rewards-vulture,
     * the callback sent to the backend is rewards-vulture, not the hardcoded wallet URL.
     */
    startWalletSessionCallBack: AppRuntime.origin,
    ppiStartWalletSession: `${environment.baseApiUrl}${environment.apiUrls.ppiStartWalletSession}`,

    // --- Token & Payout Info ---
    dwTokenInfo: `${environment.baseApiUrl}${environment.apiUrls.dwTokenInfo}`,
    setdefaultpaymentUrl: `${environment.baseApiUrl}${environment.apiUrls.setdefaultpaymentUrl}`,
    deletepaymentUrl: `${environment.baseApiUrl}${environment.apiUrls.deletepaymentUrl}`,
    dwPayoutTokenInfo:`${environment.baseApiUrl}${environment.apiUrls.dwPayoutTokenInfo}`,
    dwDeletePayoutToken:`${environment.baseApiUrl}${environment.apiUrls.dwDeletePayoutToken}`,
    initiateCashTransfer: `${environment.walletbaseApiUrl}${environment.apiUrls.initiateCashTransfer}`, 

    ppGetTokenInfo: `${environment.walletbaseApiUrl}${environment.apiUrls.ppGetTokenInfo}`,
    ppGetPayoutTokens: `${environment.walletbaseApiUrl}${environment.apiUrls.ppGetPayoutTokens}`,

    // --- Notifications ---
    appNotification: `${environment.walletbaseApiUrl}${environment.apiUrls.appNotification}`,
    setAppNotification: `${environment.walletbaseApiUrl}${environment.apiUrls.setAppNotification}`,

    // --- Third Party & NextGen ---
    getWalletSummary: `DigitalWalletAPI/dwwalletsummary`, 
    getAutoPaySequence2: `DigitalWalletAPI/dwgetautopaysequence`,
    setautotransfer: `${environment.walletbaseApiUrl}DigitalWalletAPI/dwsetwalletautotransferapp`,
    authorizenetaddpayment:`${environment.authorizeNetDomain}customer/addpayment`,
    authorizeneteditpayment:`${environment.authorizeNetDomain}customer/editpayment`,

    authSession: `${environment.walletbaseApiUrlNextGen}Auth0/DWAuthorizeUPSdotcomSession`,
    dwUpdateWalletStatus: `${environment.walletbaseApiUrlNextGen}${environment.apiUrls.dwUpdateWalletStatus}`,
    dwGetMaritzUrl: `${environment.walletbaseApiUrlNextGen}${environment.apiUrls.dwGetMaritzUrl}`,
    dwGetInvoiceDetails: `${environment.walletbaseApiUrlNextGen}${environment.apiUrls.dwGetInvoiceDetails}`,
    dwMakeInvoiceDetails: `${environment.walletbaseApiUrlNextGen}${environment.apiUrls.dwMakeInvoiceDetails}`,

    // --- Auth0 & Interceptor Config ---
    // If you need the domain/clientId for dynamic injection:
    auth0Domain: environment.auth0.domain,
    auth0ClientId: environment.auth0.clientId,
    interceptorAllowedUrl: `${environment.walletbaseApiUrlNextGen}*`,
    auth0SSODomain: environment.auth0SSO.domain,
    auth0SSOClientId: environment.auth0SSO.clientId,

    // Tealium Properties
    tealiumProfile: environment.tealium?.profile || 'maestro',
    tealiumEnv: environment.tealium?.env || 'dev'

};